"use client";

import { Market } from "@features/market/config/i18n-config";
import { viewItemEvent } from "@features/tracking/gtm/viewItemEvent";
import { TrackedCustomProduct } from "@features/tracking/utils";
import { sendVoyadoProductViewEvent } from "@features/tracking/voyado-tracking";
import { useEffect } from "react";

type ProductTrackingProps = {
  product: TrackedCustomProduct;
  market: Market;
};

export default function ProductTracking({
  product,
  market,
}: ProductTrackingProps) {
  useEffect(() => {
    const categoryName = [
      product.item_category,
      product.item_category2,
      product.item_category3,
    ]
      .filter(Boolean)
      .join(" / ");
    viewItemEvent({ product, currency: market.currency });
    sendVoyadoProductViewEvent({
      locale: market.contentfulLocale,
      itemId: product.item_id,
      categoryName,
    });
  }, [product, market]);

  return null;
}
